export const fixtureData = [
    {
        id: 24287,
        category: 'Grains',
        product: 'Corn',
        previous: 6314,
        current: 5814,
        gainDx: 25574,
        dealType: 'Financial',
        portfolio: 'Income',
    },
    {
        id: 24361,
        category: 'Grains',
        product: 'Rough Rice',
        previous: 41023,
        current: 22023,
        gainDx: 27338,
        dealType: 'Financial',
        portfolio: 'Speculative',
    },
    {
        id: 24809,
        category: 'Syntetic fabrics',
        product: 'Nylon',
        previous: 1033,
        current: 533,
        gainDx: 21907,
        dealType: 'Financial',
        portfolio: 'Defensive',
    },
    {
        id: 25216,
        category: 'Industrial Metals',
        product: 'LME Copper',
        previous: 43291,
        current: 24291,
        gainDx: 22786,
        dealType: 'Financial',
        portfolio: 'Aggressive',
    },
    {
        id: 25467,
        category: 'Construction Products',
        product: 'Ceramic Floor and Wall Tile',
        previous: 21204,
        current: 2204,
        gainDx: 12209,
        dealType: 'Financial',
        portfolio: 'Aggressive',
    },
    {
        id: 25680,
        category: 'Plastics',
        product: 'Polyphenylene Oxide',
        previous: 38428,
        current: 19428,
        gainDx: 20097,
        dealType: 'Financial',
        portfolio: 'Aggressive',
    },
];
